<template>
  <div v-html="sanitizedHtml"></div>
</template>

<script>
import sanitizeHtml from 'sanitize-html';

export default {
  props: {
    htmlContent: {
      type: String,
      required: true
    }
  },
  computed: {
    sanitizedHtml() {
      return sanitizeHtml(this.htmlContent, {
        allowedTags: ['p', 'strong', 'em', 'ol', 'ul', 'li', 'br', 'a'],
        allowedAttributes: {
          a: ['href', 'target']
        }
      });
    }
  }
};
</script>
